import FlightSearchContainer from './FlightSearchContainer'

export default FlightSearchContainer
